// Function to handle loading and executing scripts from an HTML string
const loadScriptsFromHtmlString = async (htmlString) => {
	// Parse the HTML string to extract script tags
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, 'text/html');

	// Extract script tags from the parsed HTML
	const scripts = doc.querySelectorAll('script');

	// Separate external and inline scripts
	const externalScripts = [];
	const inlineScripts = [];

	scripts.forEach((script) => {
		if (script.src) {
			externalScripts.push(script);
		} else {
			inlineScripts.push(script);
		}
	});

	// Load all external scripts first
	const scriptPromises = externalScripts.map((script) => new Promise((resolve, reject) => {
		const newScript = document.createElement('script');
		newScript.src = script.src;
		newScript.onload = () => {
			console.log(`Loaded external script: ${script.src}`);
			resolve();
		};
		newScript.onerror = () => {
			console.error(`Error loading script: ${script.src}`);
			reject(new Error(`Failed to load: ${script.src}`));
		};
		document.body.appendChild(newScript);
	}));

	// Wait for all external scripts to be loaded
	await Promise.all(scriptPromises);

	// Once all external scripts are loaded, execute inline scripts
	inlineScripts.forEach((script) => {
		const newScript = document.createElement('script');
		newScript.textContent = script.textContent;
		document.body.appendChild(newScript);
	});
};

const insertPopups = async () => {
	// Get the post ID and REST URL from the global variable.
	const { restUrl, postId } = window.emPopups;

	try {
		// Fetch the popup HTML from the REST API.
		const request = await fetch(`${restUrl}?post=${postId}`);

		// Parse the JSON response.
		const json = await request.json();

		// Get the HTML from the JSON response.
		const { data: html, success } = json;

		if (success) {
			// Create a container element and insert the HTML.
			const container = document.createElement('div');
			container.classList.add('em-popups-container');

			// Append the HTML content (without scripts) to the container
			container.innerHTML = html;
			document.body.appendChild(container);

			// Load and execute all scripts from the HTML string
			await loadScriptsFromHtmlString(html);

			// Dispatch a custom event to notify that the popup has been launched
			const event = new CustomEvent('emPopupReady', {
				detail: {
					postId,
					success,
					html,
				},
			});
			window.dispatchEvent(event);
		} else {
			console.error('Popup fetching failed.');
		}
	} catch (error) {
		console.error('Error fetching and inserting popups:', error);
	}
};

window.addEventListener('load', insertPopups);
